import { render } from "./LatestHomes.vue?vue&type=template&id=40b0599d"
import script from "./LatestHomes.vue?vue&type=script&lang=js"
export * from "./LatestHomes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__